module.exports = __webpack_public_path__ + "media/img/not-found-47722deda999198ead36179bd2854d6e.png";